module.exports = __webpack_public_path__ + "img/img-development-step-02.png";